<template>
    <div class="form-group" data-id="form-markdown">
        <label for="">
            <span class="label-title" data-id="label-title">{{field.label}}</span>
            <span v-if="field.required" class="required-field">*</span>
        </label>
         <markdown-editor v-model="field.value" :configs="easyMDEConfigs" ref="markdownEditor" ></markdown-editor>
    </div>
</template>

<script type="text/javascript">
    import markdownEditor from "vue-easymde/src/markdown-editor.vue";

    export default {
        name: 'form-markdown',
        props: ['FieldData', 'config'],
        components:{
            markdownEditor,
        },
        data() {
            return {
                field: this.FieldData,
                easyMDEConfigs : {
                    hideIcons : ['fullscreen', 'side-by-side'],
                    autoDownloadFontAwesome: false,
                }
            }
        },
        mounted() {
            this.$emit('input', this.field.value);

            if (this.config != null) {
                this.easyMDEConfigs = this.config;
            }
        }
    };
</script>

<style scoped lang="scss">
    .required-field{
        font-size: 16px;
        color: #AB5755;
        position: absolute;
        top: -4px;
    }
    label {
        position: relative;
    }
</style>
